import React from "react";
import { observer } from "mobx-react-lite";

import dateService from "../../../../../services/date-service/DateService";
import { translationService } from "../../../../../services/translation/TranslationService";
import "./SubscriptionDateBanner.scss";

interface SubscriptionDateBannerProps {
  isSubscriptionCurrentlyActive: boolean;
  isActiveInNextBillingPeriod: boolean;
  nextBillingDate?: Date;
  subscriptionWillBeCanceled: boolean;
}

export const SubscriptionDateBanner = observer((props: SubscriptionDateBannerProps) => {
  return (
    <div>
      {props.isActiveInNextBillingPeriod && props.isSubscriptionCurrentlyActive && (
        <div className="header-subscribed">
          {translationService.translate("SubscriptionPlans.card.renewal-on", {
            nextPaymentDate1: dateService.formatDate(props.nextBillingDate!, "P p"),
          })}
        </div>
      )}
      {props.isActiveInNextBillingPeriod && !props.isSubscriptionCurrentlyActive && (
        <div className="header-subscribed">
          {translationService.translate("SubscriptionPlans.card.starts-on", {
            nextPaymentDate: dateService.formatDate(props.nextBillingDate!, "P p"),
          })}
        </div>
      )}
      {!props.isActiveInNextBillingPeriod && props.isSubscriptionCurrentlyActive && (
        <div className={`header-subscribed ${props.subscriptionWillBeCanceled ? "red" : ""}`}>
          {translationService.translate("SubscriptionPlans.card.ends-on", {
            nextPaymentDate: dateService.formatDate(props.nextBillingDate!, "P p"),
          })}
        </div>
      )}
    </div>
  );
});
